<div [hidden]="view3dService.error" id="forgeViewer"></div>
<select id="models"></select>

<div [hidden]="!view3dService.error" class="text-danger">
  {{ view3dService.error }}
</div>
